const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product-card-favorite',
};

document.addEventListener('DOMContentLoaded', () => {
  initButtons();
  initGrid();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  // console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();
  handleItems();

  let type = window.localStorage.getItem('ls.biribox.view-type');

      if (type == 'private') {
        $('[data-visible="business"]').each((i, item) => {
          $(item).hide()
        });
        $('[data-visible="private"]').each((i, item) => {
          $(item).show()
        });
      } else {
        $('[data-visible="business"]').each((i, item) => {
          console.log('i', item);
          $(item).show()
        });
        $('[data-visible="private"]').each((i, item) => {
          $(item).hide()
        });
      }

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener('click', () => {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

const handleItems= () => {

    $('.add-to-cart').on('click', (evt) => {
        const parent = $(evt.target).parents('.product-description');
        const ID = $(parent).find('input[name="productId"]').val();
        const title = $(parent).find('input[name="productTitle"]').val();

        const quantity = $(parent).find('input[name="quantity"]').eq(0).length ? $(parent).find('input[name="quantity"]').val() : 1;
        
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity,
                id: ID
            },
            dataType: 'json', 
            success: function (data) { 
              window.showToast(`${window.globalTranslations.addToCart}: ${title} `);
            },
            error: function(data) {
              window.showToast(data.responseJSON.description, 'error');
            },
            complete: function() {
                getHandleCart();
            }
        });
    });

    $('button[data-action="remove-from-cart"]').on('click', (evt) => {
        const variantId = $(evt.target).attr('data-variant-id');
        
        removeFromCart(variantId)
    });

    $('button[data-action="decrease-quantity"]').on('click', (evt) => {
        const parent = $(evt.target).parents('.item-cart');
        const variantId = $(evt.target).attr('data-variant-id');
        let quantity = parseInt($(parent).find('.quantity h3').text()) - 1;

        updateFromCart(variantId, quantity)
    });

    $('button[data-action="increase-quantity"]').on('click', (evt) => {
        const parent = $(evt.target).parents('.item-cart');
        const variantId = $(evt.target).attr('data-variant-id');
        let quantity = parseInt($(parent).find('.quantity h3').text()) + 1;

        updateFromCart(variantId, quantity)
    });
}

const getHandleCart = () => {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function (data) { 
            $('#total-on-cart').css('display', 'none');

            for(let i = 0; i < data.items.length; i++) {
                if(data.item_count){
                    $('#total-on-cart').text(data.item_count).css('display', 'flex');
                }
            }

            if(data.items.length) {
                $('#checkout-available').show();
                $('#checkout-unavailable').hide();

                localStorage.setItem('current-cart', JSON.stringify(data.items));
            }
        }
    });
}